import { inputTypes } from 'components/common/FormElements/Input'
import {
  USER_PLAN_DROP_OFF,
  USER_PLAN_WAIT,
  USER_PLAN_DROP_OFF_DESCRIPTION,
  USER_PLAN_WAIT_DESCRIPTION
} from 'constant'
import { USER_PLAN, WAIT_DROPOFF_HEADER_ID } from 'components/AppointmentConfirmationPage/constants.js'

export default {
  userPlan: {
    dropOff: {
      label: 'Drop Off Car',
      name: USER_PLAN,
      type: 'radio',
      value: USER_PLAN_DROP_OFF,
      inputType: inputTypes.RADIO_INPUT,
      description: USER_PLAN_DROP_OFF_DESCRIPTION,
      'aria-describedby': WAIT_DROPOFF_HEADER_ID
    },
    wait: {
      label: 'Wait in Store',
      name: USER_PLAN,
      type: 'radio',
      value: USER_PLAN_WAIT,
      inputType: inputTypes.RADIO_INPUT,
      description: USER_PLAN_WAIT_DESCRIPTION,
      'aria-describedby': WAIT_DROPOFF_HEADER_ID
    }
  }
}
